"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgSubmitSyncActionSignerResponse = exports.MsgSubmitSyncActionSigner = exports.MsgCreateSyncActionSignerResponse = exports.MsgCreateSyncActionSigner = exports.MsgDeleteActionSignerConfigResponse = exports.MsgDeleteActionSignerConfig = exports.MsgUpdateActionSignerConfigResponse = exports.MsgUpdateActionSignerConfig = exports.MsgCreateActionSignerConfigResponse = exports.MsgCreateActionSignerConfig = exports.MsgDeleteActionSignerResponse = exports.MsgDeleteActionSigner = exports.MsgUpdateActionSignerResponse = exports.MsgUpdateActionSigner = exports.MsgCreateActionSignerResponse = exports.MsgCreateActionSigner = exports.MsgSetMinimumConfirmationResponse = exports.MsgSetMinimumConfirmation = exports.MsgSubmitVerifyCollectionOwnerResponse = exports.MsgSubmitVerifyCollectionOwner = exports.MsgCreateVerifyCollectionOwnerRequestResponse = exports.MsgCreateVerifyCollectionOwnerRequest = exports.MsgSubmitActionResponseResponse = exports.MsgSubmitActionResponse = exports.MsgCreateActionRequestResponse = exports.MsgCreateActionRequest = exports.MsgSubmitMintResponseResponse = exports.MsgSubmitMintResponse = exports.MsgCreateMintRequestResponse = exports.MsgCreateMintRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const minimal_1 = require("protobufjs/minimal");
exports.protobufPackage = "thesixnetwork.sixnft.nftoracle";
const baseMsgCreateMintRequest = {
    creator: "",
    nftSchemaCode: "",
    tokenId: "",
    requiredConfirm: 0,
};
exports.MsgCreateMintRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.tokenId !== "") {
            writer.uint32(26).string(message.tokenId);
        }
        if (message.requiredConfirm !== 0) {
            writer.uint32(32).uint64(message.requiredConfirm);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateMintRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.tokenId = reader.string();
                    break;
                case 4:
                    message.requiredConfirm = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateMintRequest);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = String(object.tokenId);
        }
        else {
            message.tokenId = "";
        }
        if (object.requiredConfirm !== undefined &&
            object.requiredConfirm !== null) {
            message.requiredConfirm = Number(object.requiredConfirm);
        }
        else {
            message.requiredConfirm = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.tokenId !== undefined && (obj.tokenId = message.tokenId);
        message.requiredConfirm !== undefined &&
            (obj.requiredConfirm = message.requiredConfirm);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateMintRequest);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = object.tokenId;
        }
        else {
            message.tokenId = "";
        }
        if (object.requiredConfirm !== undefined &&
            object.requiredConfirm !== null) {
            message.requiredConfirm = object.requiredConfirm;
        }
        else {
            message.requiredConfirm = 0;
        }
        return message;
    },
};
const baseMsgCreateMintRequestResponse = {
    id: 0,
    nftSchemaCode: "",
    tokenId: "",
};
exports.MsgCreateMintRequestResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.tokenId !== "") {
            writer.uint32(26).string(message.tokenId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateMintRequestResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.uint64());
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.tokenId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateMintRequestResponse);
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = String(object.tokenId);
        }
        else {
            message.tokenId = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.tokenId !== undefined && (obj.tokenId = message.tokenId);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateMintRequestResponse);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = object.tokenId;
        }
        else {
            message.tokenId = "";
        }
        return message;
    },
};
const baseMsgSubmitMintResponse = {
    creator: "",
    mintRequestID: 0,
    base64NftData: "",
};
exports.MsgSubmitMintResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.mintRequestID !== 0) {
            writer.uint32(16).uint64(message.mintRequestID);
        }
        if (message.base64NftData !== "") {
            writer.uint32(26).string(message.base64NftData);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSubmitMintResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.mintRequestID = longToNumber(reader.uint64());
                    break;
                case 3:
                    message.base64NftData = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSubmitMintResponse);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.mintRequestID !== undefined && object.mintRequestID !== null) {
            message.mintRequestID = Number(object.mintRequestID);
        }
        else {
            message.mintRequestID = 0;
        }
        if (object.base64NftData !== undefined && object.base64NftData !== null) {
            message.base64NftData = String(object.base64NftData);
        }
        else {
            message.base64NftData = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.mintRequestID !== undefined &&
            (obj.mintRequestID = message.mintRequestID);
        message.base64NftData !== undefined &&
            (obj.base64NftData = message.base64NftData);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSubmitMintResponse);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.mintRequestID !== undefined && object.mintRequestID !== null) {
            message.mintRequestID = object.mintRequestID;
        }
        else {
            message.mintRequestID = 0;
        }
        if (object.base64NftData !== undefined && object.base64NftData !== null) {
            message.base64NftData = object.base64NftData;
        }
        else {
            message.base64NftData = "";
        }
        return message;
    },
};
const baseMsgSubmitMintResponseResponse = { mintRequestID: "" };
exports.MsgSubmitMintResponseResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.mintRequestID !== "") {
            writer.uint32(10).string(message.mintRequestID);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSubmitMintResponseResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mintRequestID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSubmitMintResponseResponse);
        if (object.mintRequestID !== undefined && object.mintRequestID !== null) {
            message.mintRequestID = String(object.mintRequestID);
        }
        else {
            message.mintRequestID = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.mintRequestID !== undefined &&
            (obj.mintRequestID = message.mintRequestID);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSubmitMintResponseResponse);
        if (object.mintRequestID !== undefined && object.mintRequestID !== null) {
            message.mintRequestID = object.mintRequestID;
        }
        else {
            message.mintRequestID = "";
        }
        return message;
    },
};
const baseMsgCreateActionRequest = {
    creator: "",
    vm: "",
    base64ActionSignature: "",
    requiredConfirm: 0,
};
exports.MsgCreateActionRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.vm !== "") {
            writer.uint32(18).string(message.vm);
        }
        if (message.base64ActionSignature !== "") {
            writer.uint32(26).string(message.base64ActionSignature);
        }
        if (message.requiredConfirm !== 0) {
            writer.uint32(32).uint64(message.requiredConfirm);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateActionRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.vm = reader.string();
                    break;
                case 3:
                    message.base64ActionSignature = reader.string();
                    break;
                case 4:
                    message.requiredConfirm = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateActionRequest);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.vm !== undefined && object.vm !== null) {
            message.vm = String(object.vm);
        }
        else {
            message.vm = "";
        }
        if (object.base64ActionSignature !== undefined &&
            object.base64ActionSignature !== null) {
            message.base64ActionSignature = String(object.base64ActionSignature);
        }
        else {
            message.base64ActionSignature = "";
        }
        if (object.requiredConfirm !== undefined &&
            object.requiredConfirm !== null) {
            message.requiredConfirm = Number(object.requiredConfirm);
        }
        else {
            message.requiredConfirm = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.vm !== undefined && (obj.vm = message.vm);
        message.base64ActionSignature !== undefined &&
            (obj.base64ActionSignature = message.base64ActionSignature);
        message.requiredConfirm !== undefined &&
            (obj.requiredConfirm = message.requiredConfirm);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateActionRequest);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.vm !== undefined && object.vm !== null) {
            message.vm = object.vm;
        }
        else {
            message.vm = "";
        }
        if (object.base64ActionSignature !== undefined &&
            object.base64ActionSignature !== null) {
            message.base64ActionSignature = object.base64ActionSignature;
        }
        else {
            message.base64ActionSignature = "";
        }
        if (object.requiredConfirm !== undefined &&
            object.requiredConfirm !== null) {
            message.requiredConfirm = object.requiredConfirm;
        }
        else {
            message.requiredConfirm = 0;
        }
        return message;
    },
};
const baseMsgCreateActionRequestResponse = { id: 0 };
exports.MsgCreateActionRequestResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateActionRequestResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateActionRequestResponse);
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateActionRequestResponse);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        return message;
    },
};
const baseMsgSubmitActionResponse = {
    creator: "",
    actionRequestID: 0,
    base64NftData: "",
};
exports.MsgSubmitActionResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.actionRequestID !== 0) {
            writer.uint32(16).uint64(message.actionRequestID);
        }
        if (message.base64NftData !== "") {
            writer.uint32(26).string(message.base64NftData);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSubmitActionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.actionRequestID = longToNumber(reader.uint64());
                    break;
                case 3:
                    message.base64NftData = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSubmitActionResponse);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.actionRequestID !== undefined &&
            object.actionRequestID !== null) {
            message.actionRequestID = Number(object.actionRequestID);
        }
        else {
            message.actionRequestID = 0;
        }
        if (object.base64NftData !== undefined && object.base64NftData !== null) {
            message.base64NftData = String(object.base64NftData);
        }
        else {
            message.base64NftData = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.actionRequestID !== undefined &&
            (obj.actionRequestID = message.actionRequestID);
        message.base64NftData !== undefined &&
            (obj.base64NftData = message.base64NftData);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSubmitActionResponse);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.actionRequestID !== undefined &&
            object.actionRequestID !== null) {
            message.actionRequestID = object.actionRequestID;
        }
        else {
            message.actionRequestID = 0;
        }
        if (object.base64NftData !== undefined && object.base64NftData !== null) {
            message.base64NftData = object.base64NftData;
        }
        else {
            message.base64NftData = "";
        }
        return message;
    },
};
const baseMsgSubmitActionResponseResponse = { actionRequestID: "" };
exports.MsgSubmitActionResponseResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.actionRequestID !== "") {
            writer.uint32(10).string(message.actionRequestID);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSubmitActionResponseResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actionRequestID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSubmitActionResponseResponse);
        if (object.actionRequestID !== undefined &&
            object.actionRequestID !== null) {
            message.actionRequestID = String(object.actionRequestID);
        }
        else {
            message.actionRequestID = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.actionRequestID !== undefined &&
            (obj.actionRequestID = message.actionRequestID);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSubmitActionResponseResponse);
        if (object.actionRequestID !== undefined &&
            object.actionRequestID !== null) {
            message.actionRequestID = object.actionRequestID;
        }
        else {
            message.actionRequestID = "";
        }
        return message;
    },
};
const baseMsgCreateVerifyCollectionOwnerRequest = {
    creator: "",
    nftSchemaCode: "",
    base64VerifyRequestorSignature: "",
    requiredConfirm: 0,
};
exports.MsgCreateVerifyCollectionOwnerRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.base64VerifyRequestorSignature !== "") {
            writer.uint32(26).string(message.base64VerifyRequestorSignature);
        }
        if (message.requiredConfirm !== 0) {
            writer.uint32(32).uint64(message.requiredConfirm);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateVerifyCollectionOwnerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.base64VerifyRequestorSignature = reader.string();
                    break;
                case 4:
                    message.requiredConfirm = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateVerifyCollectionOwnerRequest);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.base64VerifyRequestorSignature !== undefined &&
            object.base64VerifyRequestorSignature !== null) {
            message.base64VerifyRequestorSignature = String(object.base64VerifyRequestorSignature);
        }
        else {
            message.base64VerifyRequestorSignature = "";
        }
        if (object.requiredConfirm !== undefined &&
            object.requiredConfirm !== null) {
            message.requiredConfirm = Number(object.requiredConfirm);
        }
        else {
            message.requiredConfirm = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.base64VerifyRequestorSignature !== undefined &&
            (obj.base64VerifyRequestorSignature =
                message.base64VerifyRequestorSignature);
        message.requiredConfirm !== undefined &&
            (obj.requiredConfirm = message.requiredConfirm);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateVerifyCollectionOwnerRequest);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.base64VerifyRequestorSignature !== undefined &&
            object.base64VerifyRequestorSignature !== null) {
            message.base64VerifyRequestorSignature =
                object.base64VerifyRequestorSignature;
        }
        else {
            message.base64VerifyRequestorSignature = "";
        }
        if (object.requiredConfirm !== undefined &&
            object.requiredConfirm !== null) {
            message.requiredConfirm = object.requiredConfirm;
        }
        else {
            message.requiredConfirm = 0;
        }
        return message;
    },
};
const baseMsgCreateVerifyCollectionOwnerRequestResponse = {
    id: 0,
    nftSchemaCode: "",
    ownerAddress: "",
};
exports.MsgCreateVerifyCollectionOwnerRequestResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(18).string(message.nftSchemaCode);
        }
        if (message.ownerAddress !== "") {
            writer.uint32(26).string(message.ownerAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateVerifyCollectionOwnerRequestResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.uint64());
                    break;
                case 2:
                    message.nftSchemaCode = reader.string();
                    break;
                case 3:
                    message.ownerAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateVerifyCollectionOwnerRequestResponse);
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateVerifyCollectionOwnerRequestResponse);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        return message;
    },
};
const baseMsgSubmitVerifyCollectionOwner = {
    creator: "",
    verifyRequestID: 0,
    nftSchemaCode: "",
    base64OriginContractInfo: "",
};
exports.MsgSubmitVerifyCollectionOwner = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.verifyRequestID !== 0) {
            writer.uint32(16).uint64(message.verifyRequestID);
        }
        if (message.nftSchemaCode !== "") {
            writer.uint32(26).string(message.nftSchemaCode);
        }
        if (message.base64OriginContractInfo !== "") {
            writer.uint32(34).string(message.base64OriginContractInfo);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSubmitVerifyCollectionOwner);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.verifyRequestID = longToNumber(reader.uint64());
                    break;
                case 3:
                    message.nftSchemaCode = reader.string();
                    break;
                case 4:
                    message.base64OriginContractInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSubmitVerifyCollectionOwner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.verifyRequestID !== undefined &&
            object.verifyRequestID !== null) {
            message.verifyRequestID = Number(object.verifyRequestID);
        }
        else {
            message.verifyRequestID = 0;
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.base64OriginContractInfo !== undefined &&
            object.base64OriginContractInfo !== null) {
            message.base64OriginContractInfo = String(object.base64OriginContractInfo);
        }
        else {
            message.base64OriginContractInfo = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.verifyRequestID !== undefined &&
            (obj.verifyRequestID = message.verifyRequestID);
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.base64OriginContractInfo !== undefined &&
            (obj.base64OriginContractInfo = message.base64OriginContractInfo);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSubmitVerifyCollectionOwner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.verifyRequestID !== undefined &&
            object.verifyRequestID !== null) {
            message.verifyRequestID = object.verifyRequestID;
        }
        else {
            message.verifyRequestID = 0;
        }
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.base64OriginContractInfo !== undefined &&
            object.base64OriginContractInfo !== null) {
            message.base64OriginContractInfo = object.base64OriginContractInfo;
        }
        else {
            message.base64OriginContractInfo = "";
        }
        return message;
    },
};
const baseMsgSubmitVerifyCollectionOwnerResponse = {
    verifyRequestID: 0,
};
exports.MsgSubmitVerifyCollectionOwnerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.verifyRequestID !== 0) {
            writer.uint32(8).uint64(message.verifyRequestID);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSubmitVerifyCollectionOwnerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.verifyRequestID = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSubmitVerifyCollectionOwnerResponse);
        if (object.verifyRequestID !== undefined &&
            object.verifyRequestID !== null) {
            message.verifyRequestID = Number(object.verifyRequestID);
        }
        else {
            message.verifyRequestID = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.verifyRequestID !== undefined &&
            (obj.verifyRequestID = message.verifyRequestID);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSubmitVerifyCollectionOwnerResponse);
        if (object.verifyRequestID !== undefined &&
            object.verifyRequestID !== null) {
            message.verifyRequestID = object.verifyRequestID;
        }
        else {
            message.verifyRequestID = 0;
        }
        return message;
    },
};
const baseMsgSetMinimumConfirmation = {
    creator: "",
    newConfirmation: "",
};
exports.MsgSetMinimumConfirmation = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.newConfirmation !== "") {
            writer.uint32(18).string(message.newConfirmation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetMinimumConfirmation);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.newConfirmation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetMinimumConfirmation);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.newConfirmation !== undefined &&
            object.newConfirmation !== null) {
            message.newConfirmation = String(object.newConfirmation);
        }
        else {
            message.newConfirmation = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.newConfirmation !== undefined &&
            (obj.newConfirmation = message.newConfirmation);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSetMinimumConfirmation);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.newConfirmation !== undefined &&
            object.newConfirmation !== null) {
            message.newConfirmation = object.newConfirmation;
        }
        else {
            message.newConfirmation = "";
        }
        return message;
    },
};
const baseMsgSetMinimumConfirmationResponse = { newConfirmation: "" };
exports.MsgSetMinimumConfirmationResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.newConfirmation !== "") {
            writer.uint32(10).string(message.newConfirmation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetMinimumConfirmationResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.newConfirmation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetMinimumConfirmationResponse);
        if (object.newConfirmation !== undefined &&
            object.newConfirmation !== null) {
            message.newConfirmation = String(object.newConfirmation);
        }
        else {
            message.newConfirmation = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.newConfirmation !== undefined &&
            (obj.newConfirmation = message.newConfirmation);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSetMinimumConfirmationResponse);
        if (object.newConfirmation !== undefined &&
            object.newConfirmation !== null) {
            message.newConfirmation = object.newConfirmation;
        }
        else {
            message.newConfirmation = "";
        }
        return message;
    },
};
const baseMsgCreateActionSigner = {
    creator: "",
    base64EncodedSetSignerAction: "",
};
exports.MsgCreateActionSigner = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.base64EncodedSetSignerAction !== "") {
            writer.uint32(18).string(message.base64EncodedSetSignerAction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateActionSigner);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.base64EncodedSetSignerAction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateActionSigner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.base64EncodedSetSignerAction !== undefined &&
            object.base64EncodedSetSignerAction !== null) {
            message.base64EncodedSetSignerAction = String(object.base64EncodedSetSignerAction);
        }
        else {
            message.base64EncodedSetSignerAction = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.base64EncodedSetSignerAction !== undefined &&
            (obj.base64EncodedSetSignerAction = message.base64EncodedSetSignerAction);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateActionSigner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.base64EncodedSetSignerAction !== undefined &&
            object.base64EncodedSetSignerAction !== null) {
            message.base64EncodedSetSignerAction =
                object.base64EncodedSetSignerAction;
        }
        else {
            message.base64EncodedSetSignerAction = "";
        }
        return message;
    },
};
const baseMsgCreateActionSignerResponse = {
    ownerAddress: "",
    signerAddress: "",
    expireAt: "",
};
exports.MsgCreateActionSignerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.ownerAddress !== "") {
            writer.uint32(10).string(message.ownerAddress);
        }
        if (message.signerAddress !== "") {
            writer.uint32(18).string(message.signerAddress);
        }
        if (message.expireAt !== "") {
            writer.uint32(26).string(message.expireAt);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateActionSignerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ownerAddress = reader.string();
                    break;
                case 2:
                    message.signerAddress = reader.string();
                    break;
                case 3:
                    message.expireAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateActionSignerResponse);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.signerAddress !== undefined && object.signerAddress !== null) {
            message.signerAddress = String(object.signerAddress);
        }
        else {
            message.signerAddress = "";
        }
        if (object.expireAt !== undefined && object.expireAt !== null) {
            message.expireAt = String(object.expireAt);
        }
        else {
            message.expireAt = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        message.signerAddress !== undefined &&
            (obj.signerAddress = message.signerAddress);
        message.expireAt !== undefined && (obj.expireAt = message.expireAt);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateActionSignerResponse);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.signerAddress !== undefined && object.signerAddress !== null) {
            message.signerAddress = object.signerAddress;
        }
        else {
            message.signerAddress = "";
        }
        if (object.expireAt !== undefined && object.expireAt !== null) {
            message.expireAt = object.expireAt;
        }
        else {
            message.expireAt = "";
        }
        return message;
    },
};
const baseMsgUpdateActionSigner = {
    creator: "",
    base64EncodedSetSignerAction: "",
};
exports.MsgUpdateActionSigner = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.base64EncodedSetSignerAction !== "") {
            writer.uint32(18).string(message.base64EncodedSetSignerAction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateActionSigner);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.base64EncodedSetSignerAction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateActionSigner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.base64EncodedSetSignerAction !== undefined &&
            object.base64EncodedSetSignerAction !== null) {
            message.base64EncodedSetSignerAction = String(object.base64EncodedSetSignerAction);
        }
        else {
            message.base64EncodedSetSignerAction = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.base64EncodedSetSignerAction !== undefined &&
            (obj.base64EncodedSetSignerAction = message.base64EncodedSetSignerAction);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgUpdateActionSigner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.base64EncodedSetSignerAction !== undefined &&
            object.base64EncodedSetSignerAction !== null) {
            message.base64EncodedSetSignerAction =
                object.base64EncodedSetSignerAction;
        }
        else {
            message.base64EncodedSetSignerAction = "";
        }
        return message;
    },
};
const baseMsgUpdateActionSignerResponse = {
    ownerAddress: "",
    signerAddress: "",
    expireAt: "",
};
exports.MsgUpdateActionSignerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.ownerAddress !== "") {
            writer.uint32(10).string(message.ownerAddress);
        }
        if (message.signerAddress !== "") {
            writer.uint32(18).string(message.signerAddress);
        }
        if (message.expireAt !== "") {
            writer.uint32(26).string(message.expireAt);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateActionSignerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ownerAddress = reader.string();
                    break;
                case 2:
                    message.signerAddress = reader.string();
                    break;
                case 3:
                    message.expireAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateActionSignerResponse);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.signerAddress !== undefined && object.signerAddress !== null) {
            message.signerAddress = String(object.signerAddress);
        }
        else {
            message.signerAddress = "";
        }
        if (object.expireAt !== undefined && object.expireAt !== null) {
            message.expireAt = String(object.expireAt);
        }
        else {
            message.expireAt = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        message.signerAddress !== undefined &&
            (obj.signerAddress = message.signerAddress);
        message.expireAt !== undefined && (obj.expireAt = message.expireAt);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgUpdateActionSignerResponse);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.signerAddress !== undefined && object.signerAddress !== null) {
            message.signerAddress = object.signerAddress;
        }
        else {
            message.signerAddress = "";
        }
        if (object.expireAt !== undefined && object.expireAt !== null) {
            message.expireAt = object.expireAt;
        }
        else {
            message.expireAt = "";
        }
        return message;
    },
};
const baseMsgDeleteActionSigner = {
    creator: "",
    base64EncodedSetSignerAction: "",
};
exports.MsgDeleteActionSigner = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.base64EncodedSetSignerAction !== "") {
            writer.uint32(18).string(message.base64EncodedSetSignerAction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeleteActionSigner);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.base64EncodedSetSignerAction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeleteActionSigner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.base64EncodedSetSignerAction !== undefined &&
            object.base64EncodedSetSignerAction !== null) {
            message.base64EncodedSetSignerAction = String(object.base64EncodedSetSignerAction);
        }
        else {
            message.base64EncodedSetSignerAction = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.base64EncodedSetSignerAction !== undefined &&
            (obj.base64EncodedSetSignerAction = message.base64EncodedSetSignerAction);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgDeleteActionSigner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.base64EncodedSetSignerAction !== undefined &&
            object.base64EncodedSetSignerAction !== null) {
            message.base64EncodedSetSignerAction =
                object.base64EncodedSetSignerAction;
        }
        else {
            message.base64EncodedSetSignerAction = "";
        }
        return message;
    },
};
const baseMsgDeleteActionSignerResponse = {
    ownerAddress: "",
    signerAddress: "",
};
exports.MsgDeleteActionSignerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.ownerAddress !== "") {
            writer.uint32(10).string(message.ownerAddress);
        }
        if (message.signerAddress !== "") {
            writer.uint32(18).string(message.signerAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeleteActionSignerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ownerAddress = reader.string();
                    break;
                case 2:
                    message.signerAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeleteActionSignerResponse);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.signerAddress !== undefined && object.signerAddress !== null) {
            message.signerAddress = String(object.signerAddress);
        }
        else {
            message.signerAddress = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        message.signerAddress !== undefined &&
            (obj.signerAddress = message.signerAddress);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgDeleteActionSignerResponse);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.signerAddress !== undefined && object.signerAddress !== null) {
            message.signerAddress = object.signerAddress;
        }
        else {
            message.signerAddress = "";
        }
        return message;
    },
};
const baseMsgCreateActionSignerConfig = {
    creator: "",
    chain: "",
    rpc_endpoint: "",
    contractAddress: "",
    contractName: "",
    contractOwner: "",
};
exports.MsgCreateActionSignerConfig = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.chain !== "") {
            writer.uint32(18).string(message.chain);
        }
        if (message.rpc_endpoint !== "") {
            writer.uint32(26).string(message.rpc_endpoint);
        }
        if (message.contractAddress !== "") {
            writer.uint32(34).string(message.contractAddress);
        }
        if (message.contractName !== "") {
            writer.uint32(42).string(message.contractName);
        }
        if (message.contractOwner !== "") {
            writer.uint32(50).string(message.contractOwner);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateActionSignerConfig);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chain = reader.string();
                    break;
                case 3:
                    message.rpc_endpoint = reader.string();
                    break;
                case 4:
                    message.contractAddress = reader.string();
                    break;
                case 5:
                    message.contractName = reader.string();
                    break;
                case 6:
                    message.contractOwner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateActionSignerConfig);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = String(object.chain);
        }
        else {
            message.chain = "";
        }
        if (object.rpc_endpoint !== undefined && object.rpc_endpoint !== null) {
            message.rpc_endpoint = String(object.rpc_endpoint);
        }
        else {
            message.rpc_endpoint = "";
        }
        if (object.contractAddress !== undefined &&
            object.contractAddress !== null) {
            message.contractAddress = String(object.contractAddress);
        }
        else {
            message.contractAddress = "";
        }
        if (object.contractName !== undefined && object.contractName !== null) {
            message.contractName = String(object.contractName);
        }
        else {
            message.contractName = "";
        }
        if (object.contractOwner !== undefined && object.contractOwner !== null) {
            message.contractOwner = String(object.contractOwner);
        }
        else {
            message.contractOwner = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chain !== undefined && (obj.chain = message.chain);
        message.rpc_endpoint !== undefined &&
            (obj.rpc_endpoint = message.rpc_endpoint);
        message.contractAddress !== undefined &&
            (obj.contractAddress = message.contractAddress);
        message.contractName !== undefined &&
            (obj.contractName = message.contractName);
        message.contractOwner !== undefined &&
            (obj.contractOwner = message.contractOwner);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateActionSignerConfig);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = object.chain;
        }
        else {
            message.chain = "";
        }
        if (object.rpc_endpoint !== undefined && object.rpc_endpoint !== null) {
            message.rpc_endpoint = object.rpc_endpoint;
        }
        else {
            message.rpc_endpoint = "";
        }
        if (object.contractAddress !== undefined &&
            object.contractAddress !== null) {
            message.contractAddress = object.contractAddress;
        }
        else {
            message.contractAddress = "";
        }
        if (object.contractName !== undefined && object.contractName !== null) {
            message.contractName = object.contractName;
        }
        else {
            message.contractName = "";
        }
        if (object.contractOwner !== undefined && object.contractOwner !== null) {
            message.contractOwner = object.contractOwner;
        }
        else {
            message.contractOwner = "";
        }
        return message;
    },
};
const baseMsgCreateActionSignerConfigResponse = {
    chain: "",
    rpc_endpoint: "",
    contractAddress: "",
    contractName: "",
    contractOwner: "",
};
exports.MsgCreateActionSignerConfigResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.chain !== "") {
            writer.uint32(10).string(message.chain);
        }
        if (message.rpc_endpoint !== "") {
            writer.uint32(18).string(message.rpc_endpoint);
        }
        if (message.contractAddress !== "") {
            writer.uint32(26).string(message.contractAddress);
        }
        if (message.contractName !== "") {
            writer.uint32(34).string(message.contractName);
        }
        if (message.contractOwner !== "") {
            writer.uint32(42).string(message.contractOwner);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateActionSignerConfigResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chain = reader.string();
                    break;
                case 2:
                    message.rpc_endpoint = reader.string();
                    break;
                case 3:
                    message.contractAddress = reader.string();
                    break;
                case 4:
                    message.contractName = reader.string();
                    break;
                case 5:
                    message.contractOwner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateActionSignerConfigResponse);
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = String(object.chain);
        }
        else {
            message.chain = "";
        }
        if (object.rpc_endpoint !== undefined && object.rpc_endpoint !== null) {
            message.rpc_endpoint = String(object.rpc_endpoint);
        }
        else {
            message.rpc_endpoint = "";
        }
        if (object.contractAddress !== undefined &&
            object.contractAddress !== null) {
            message.contractAddress = String(object.contractAddress);
        }
        else {
            message.contractAddress = "";
        }
        if (object.contractName !== undefined && object.contractName !== null) {
            message.contractName = String(object.contractName);
        }
        else {
            message.contractName = "";
        }
        if (object.contractOwner !== undefined && object.contractOwner !== null) {
            message.contractOwner = String(object.contractOwner);
        }
        else {
            message.contractOwner = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.chain !== undefined && (obj.chain = message.chain);
        message.rpc_endpoint !== undefined &&
            (obj.rpc_endpoint = message.rpc_endpoint);
        message.contractAddress !== undefined &&
            (obj.contractAddress = message.contractAddress);
        message.contractName !== undefined &&
            (obj.contractName = message.contractName);
        message.contractOwner !== undefined &&
            (obj.contractOwner = message.contractOwner);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateActionSignerConfigResponse);
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = object.chain;
        }
        else {
            message.chain = "";
        }
        if (object.rpc_endpoint !== undefined && object.rpc_endpoint !== null) {
            message.rpc_endpoint = object.rpc_endpoint;
        }
        else {
            message.rpc_endpoint = "";
        }
        if (object.contractAddress !== undefined &&
            object.contractAddress !== null) {
            message.contractAddress = object.contractAddress;
        }
        else {
            message.contractAddress = "";
        }
        if (object.contractName !== undefined && object.contractName !== null) {
            message.contractName = object.contractName;
        }
        else {
            message.contractName = "";
        }
        if (object.contractOwner !== undefined && object.contractOwner !== null) {
            message.contractOwner = object.contractOwner;
        }
        else {
            message.contractOwner = "";
        }
        return message;
    },
};
const baseMsgUpdateActionSignerConfig = {
    creator: "",
    chain: "",
    rpc_endpoint: "",
    contractAddress: "",
    contractName: "",
    contractOwner: "",
};
exports.MsgUpdateActionSignerConfig = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.chain !== "") {
            writer.uint32(18).string(message.chain);
        }
        if (message.rpc_endpoint !== "") {
            writer.uint32(26).string(message.rpc_endpoint);
        }
        if (message.contractAddress !== "") {
            writer.uint32(34).string(message.contractAddress);
        }
        if (message.contractName !== "") {
            writer.uint32(42).string(message.contractName);
        }
        if (message.contractOwner !== "") {
            writer.uint32(50).string(message.contractOwner);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateActionSignerConfig);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chain = reader.string();
                    break;
                case 3:
                    message.rpc_endpoint = reader.string();
                    break;
                case 4:
                    message.contractAddress = reader.string();
                    break;
                case 5:
                    message.contractName = reader.string();
                    break;
                case 6:
                    message.contractOwner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateActionSignerConfig);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = String(object.chain);
        }
        else {
            message.chain = "";
        }
        if (object.rpc_endpoint !== undefined && object.rpc_endpoint !== null) {
            message.rpc_endpoint = String(object.rpc_endpoint);
        }
        else {
            message.rpc_endpoint = "";
        }
        if (object.contractAddress !== undefined &&
            object.contractAddress !== null) {
            message.contractAddress = String(object.contractAddress);
        }
        else {
            message.contractAddress = "";
        }
        if (object.contractName !== undefined && object.contractName !== null) {
            message.contractName = String(object.contractName);
        }
        else {
            message.contractName = "";
        }
        if (object.contractOwner !== undefined && object.contractOwner !== null) {
            message.contractOwner = String(object.contractOwner);
        }
        else {
            message.contractOwner = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chain !== undefined && (obj.chain = message.chain);
        message.rpc_endpoint !== undefined &&
            (obj.rpc_endpoint = message.rpc_endpoint);
        message.contractAddress !== undefined &&
            (obj.contractAddress = message.contractAddress);
        message.contractName !== undefined &&
            (obj.contractName = message.contractName);
        message.contractOwner !== undefined &&
            (obj.contractOwner = message.contractOwner);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgUpdateActionSignerConfig);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = object.chain;
        }
        else {
            message.chain = "";
        }
        if (object.rpc_endpoint !== undefined && object.rpc_endpoint !== null) {
            message.rpc_endpoint = object.rpc_endpoint;
        }
        else {
            message.rpc_endpoint = "";
        }
        if (object.contractAddress !== undefined &&
            object.contractAddress !== null) {
            message.contractAddress = object.contractAddress;
        }
        else {
            message.contractAddress = "";
        }
        if (object.contractName !== undefined && object.contractName !== null) {
            message.contractName = object.contractName;
        }
        else {
            message.contractName = "";
        }
        if (object.contractOwner !== undefined && object.contractOwner !== null) {
            message.contractOwner = object.contractOwner;
        }
        else {
            message.contractOwner = "";
        }
        return message;
    },
};
const baseMsgUpdateActionSignerConfigResponse = {
    chain: "",
    rpc_endpoint: "",
    new_rpc_endpoint: "",
    contractAddress: "",
    new_contractAddress: "",
    contractName: "",
    new_contractName: "",
    contractOwner: "",
    new_contractOwner: "",
};
exports.MsgUpdateActionSignerConfigResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.chain !== "") {
            writer.uint32(10).string(message.chain);
        }
        if (message.rpc_endpoint !== "") {
            writer.uint32(18).string(message.rpc_endpoint);
        }
        if (message.new_rpc_endpoint !== "") {
            writer.uint32(26).string(message.new_rpc_endpoint);
        }
        if (message.contractAddress !== "") {
            writer.uint32(34).string(message.contractAddress);
        }
        if (message.new_contractAddress !== "") {
            writer.uint32(42).string(message.new_contractAddress);
        }
        if (message.contractName !== "") {
            writer.uint32(50).string(message.contractName);
        }
        if (message.new_contractName !== "") {
            writer.uint32(58).string(message.new_contractName);
        }
        if (message.contractOwner !== "") {
            writer.uint32(66).string(message.contractOwner);
        }
        if (message.new_contractOwner !== "") {
            writer.uint32(74).string(message.new_contractOwner);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateActionSignerConfigResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chain = reader.string();
                    break;
                case 2:
                    message.rpc_endpoint = reader.string();
                    break;
                case 3:
                    message.new_rpc_endpoint = reader.string();
                    break;
                case 4:
                    message.contractAddress = reader.string();
                    break;
                case 5:
                    message.new_contractAddress = reader.string();
                    break;
                case 6:
                    message.contractName = reader.string();
                    break;
                case 7:
                    message.new_contractName = reader.string();
                    break;
                case 8:
                    message.contractOwner = reader.string();
                    break;
                case 9:
                    message.new_contractOwner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateActionSignerConfigResponse);
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = String(object.chain);
        }
        else {
            message.chain = "";
        }
        if (object.rpc_endpoint !== undefined && object.rpc_endpoint !== null) {
            message.rpc_endpoint = String(object.rpc_endpoint);
        }
        else {
            message.rpc_endpoint = "";
        }
        if (object.new_rpc_endpoint !== undefined &&
            object.new_rpc_endpoint !== null) {
            message.new_rpc_endpoint = String(object.new_rpc_endpoint);
        }
        else {
            message.new_rpc_endpoint = "";
        }
        if (object.contractAddress !== undefined &&
            object.contractAddress !== null) {
            message.contractAddress = String(object.contractAddress);
        }
        else {
            message.contractAddress = "";
        }
        if (object.new_contractAddress !== undefined &&
            object.new_contractAddress !== null) {
            message.new_contractAddress = String(object.new_contractAddress);
        }
        else {
            message.new_contractAddress = "";
        }
        if (object.contractName !== undefined && object.contractName !== null) {
            message.contractName = String(object.contractName);
        }
        else {
            message.contractName = "";
        }
        if (object.new_contractName !== undefined &&
            object.new_contractName !== null) {
            message.new_contractName = String(object.new_contractName);
        }
        else {
            message.new_contractName = "";
        }
        if (object.contractOwner !== undefined && object.contractOwner !== null) {
            message.contractOwner = String(object.contractOwner);
        }
        else {
            message.contractOwner = "";
        }
        if (object.new_contractOwner !== undefined &&
            object.new_contractOwner !== null) {
            message.new_contractOwner = String(object.new_contractOwner);
        }
        else {
            message.new_contractOwner = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.chain !== undefined && (obj.chain = message.chain);
        message.rpc_endpoint !== undefined &&
            (obj.rpc_endpoint = message.rpc_endpoint);
        message.new_rpc_endpoint !== undefined &&
            (obj.new_rpc_endpoint = message.new_rpc_endpoint);
        message.contractAddress !== undefined &&
            (obj.contractAddress = message.contractAddress);
        message.new_contractAddress !== undefined &&
            (obj.new_contractAddress = message.new_contractAddress);
        message.contractName !== undefined &&
            (obj.contractName = message.contractName);
        message.new_contractName !== undefined &&
            (obj.new_contractName = message.new_contractName);
        message.contractOwner !== undefined &&
            (obj.contractOwner = message.contractOwner);
        message.new_contractOwner !== undefined &&
            (obj.new_contractOwner = message.new_contractOwner);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgUpdateActionSignerConfigResponse);
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = object.chain;
        }
        else {
            message.chain = "";
        }
        if (object.rpc_endpoint !== undefined && object.rpc_endpoint !== null) {
            message.rpc_endpoint = object.rpc_endpoint;
        }
        else {
            message.rpc_endpoint = "";
        }
        if (object.new_rpc_endpoint !== undefined &&
            object.new_rpc_endpoint !== null) {
            message.new_rpc_endpoint = object.new_rpc_endpoint;
        }
        else {
            message.new_rpc_endpoint = "";
        }
        if (object.contractAddress !== undefined &&
            object.contractAddress !== null) {
            message.contractAddress = object.contractAddress;
        }
        else {
            message.contractAddress = "";
        }
        if (object.new_contractAddress !== undefined &&
            object.new_contractAddress !== null) {
            message.new_contractAddress = object.new_contractAddress;
        }
        else {
            message.new_contractAddress = "";
        }
        if (object.contractName !== undefined && object.contractName !== null) {
            message.contractName = object.contractName;
        }
        else {
            message.contractName = "";
        }
        if (object.new_contractName !== undefined &&
            object.new_contractName !== null) {
            message.new_contractName = object.new_contractName;
        }
        else {
            message.new_contractName = "";
        }
        if (object.contractOwner !== undefined && object.contractOwner !== null) {
            message.contractOwner = object.contractOwner;
        }
        else {
            message.contractOwner = "";
        }
        if (object.new_contractOwner !== undefined &&
            object.new_contractOwner !== null) {
            message.new_contractOwner = object.new_contractOwner;
        }
        else {
            message.new_contractOwner = "";
        }
        return message;
    },
};
const baseMsgDeleteActionSignerConfig = { creator: "", chain: "" };
exports.MsgDeleteActionSignerConfig = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.chain !== "") {
            writer.uint32(18).string(message.chain);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeleteActionSignerConfig);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chain = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeleteActionSignerConfig);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = String(object.chain);
        }
        else {
            message.chain = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chain !== undefined && (obj.chain = message.chain);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgDeleteActionSignerConfig);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = object.chain;
        }
        else {
            message.chain = "";
        }
        return message;
    },
};
const baseMsgDeleteActionSignerConfigResponse = { chain: "" };
exports.MsgDeleteActionSignerConfigResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.chain !== "") {
            writer.uint32(10).string(message.chain);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeleteActionSignerConfigResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chain = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeleteActionSignerConfigResponse);
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = String(object.chain);
        }
        else {
            message.chain = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.chain !== undefined && (obj.chain = message.chain);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgDeleteActionSignerConfigResponse);
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = object.chain;
        }
        else {
            message.chain = "";
        }
        return message;
    },
};
const baseMsgCreateSyncActionSigner = {
    creator: "",
    chain: "",
    actorAddress: "",
    ownerAddress: "",
    requiredConfirm: 0,
};
exports.MsgCreateSyncActionSigner = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.chain !== "") {
            writer.uint32(18).string(message.chain);
        }
        if (message.actorAddress !== "") {
            writer.uint32(26).string(message.actorAddress);
        }
        if (message.ownerAddress !== "") {
            writer.uint32(34).string(message.ownerAddress);
        }
        if (message.requiredConfirm !== 0) {
            writer.uint32(40).uint64(message.requiredConfirm);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateSyncActionSigner);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chain = reader.string();
                    break;
                case 3:
                    message.actorAddress = reader.string();
                    break;
                case 4:
                    message.ownerAddress = reader.string();
                    break;
                case 5:
                    message.requiredConfirm = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateSyncActionSigner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = String(object.chain);
        }
        else {
            message.chain = "";
        }
        if (object.actorAddress !== undefined && object.actorAddress !== null) {
            message.actorAddress = String(object.actorAddress);
        }
        else {
            message.actorAddress = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.requiredConfirm !== undefined &&
            object.requiredConfirm !== null) {
            message.requiredConfirm = Number(object.requiredConfirm);
        }
        else {
            message.requiredConfirm = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chain !== undefined && (obj.chain = message.chain);
        message.actorAddress !== undefined &&
            (obj.actorAddress = message.actorAddress);
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        message.requiredConfirm !== undefined &&
            (obj.requiredConfirm = message.requiredConfirm);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateSyncActionSigner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = object.chain;
        }
        else {
            message.chain = "";
        }
        if (object.actorAddress !== undefined && object.actorAddress !== null) {
            message.actorAddress = object.actorAddress;
        }
        else {
            message.actorAddress = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.requiredConfirm !== undefined &&
            object.requiredConfirm !== null) {
            message.requiredConfirm = object.requiredConfirm;
        }
        else {
            message.requiredConfirm = 0;
        }
        return message;
    },
};
const baseMsgCreateSyncActionSignerResponse = {
    id: 0,
    chain: "",
    ownerAddress: "",
    actorAddress: "",
};
exports.MsgCreateSyncActionSignerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        if (message.chain !== "") {
            writer.uint32(18).string(message.chain);
        }
        if (message.ownerAddress !== "") {
            writer.uint32(26).string(message.ownerAddress);
        }
        if (message.actorAddress !== "") {
            writer.uint32(34).string(message.actorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateSyncActionSignerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.uint64());
                    break;
                case 2:
                    message.chain = reader.string();
                    break;
                case 3:
                    message.ownerAddress = reader.string();
                    break;
                case 4:
                    message.actorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateSyncActionSignerResponse);
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = String(object.chain);
        }
        else {
            message.chain = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.actorAddress !== undefined && object.actorAddress !== null) {
            message.actorAddress = String(object.actorAddress);
        }
        else {
            message.actorAddress = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.chain !== undefined && (obj.chain = message.chain);
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        message.actorAddress !== undefined &&
            (obj.actorAddress = message.actorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreateSyncActionSignerResponse);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = object.chain;
        }
        else {
            message.chain = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.actorAddress !== undefined && object.actorAddress !== null) {
            message.actorAddress = object.actorAddress;
        }
        else {
            message.actorAddress = "";
        }
        return message;
    },
};
const baseMsgSubmitSyncActionSigner = {
    creator: "",
    syncId: 0,
    chain: "",
    actorAddress: "",
    ownerAddress: "",
    expire_epoch: "",
};
exports.MsgSubmitSyncActionSigner = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.syncId !== 0) {
            writer.uint32(16).uint64(message.syncId);
        }
        if (message.chain !== "") {
            writer.uint32(26).string(message.chain);
        }
        if (message.actorAddress !== "") {
            writer.uint32(34).string(message.actorAddress);
        }
        if (message.ownerAddress !== "") {
            writer.uint32(42).string(message.ownerAddress);
        }
        if (message.expire_epoch !== "") {
            writer.uint32(50).string(message.expire_epoch);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSubmitSyncActionSigner);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.syncId = longToNumber(reader.uint64());
                    break;
                case 3:
                    message.chain = reader.string();
                    break;
                case 4:
                    message.actorAddress = reader.string();
                    break;
                case 5:
                    message.ownerAddress = reader.string();
                    break;
                case 6:
                    message.expire_epoch = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSubmitSyncActionSigner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.syncId !== undefined && object.syncId !== null) {
            message.syncId = Number(object.syncId);
        }
        else {
            message.syncId = 0;
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = String(object.chain);
        }
        else {
            message.chain = "";
        }
        if (object.actorAddress !== undefined && object.actorAddress !== null) {
            message.actorAddress = String(object.actorAddress);
        }
        else {
            message.actorAddress = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.expire_epoch !== undefined && object.expire_epoch !== null) {
            message.expire_epoch = String(object.expire_epoch);
        }
        else {
            message.expire_epoch = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.syncId !== undefined && (obj.syncId = message.syncId);
        message.chain !== undefined && (obj.chain = message.chain);
        message.actorAddress !== undefined &&
            (obj.actorAddress = message.actorAddress);
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        message.expire_epoch !== undefined &&
            (obj.expire_epoch = message.expire_epoch);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSubmitSyncActionSigner);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.syncId !== undefined && object.syncId !== null) {
            message.syncId = object.syncId;
        }
        else {
            message.syncId = 0;
        }
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = object.chain;
        }
        else {
            message.chain = "";
        }
        if (object.actorAddress !== undefined && object.actorAddress !== null) {
            message.actorAddress = object.actorAddress;
        }
        else {
            message.actorAddress = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.expire_epoch !== undefined && object.expire_epoch !== null) {
            message.expire_epoch = object.expire_epoch;
        }
        else {
            message.expire_epoch = "";
        }
        return message;
    },
};
const baseMsgSubmitSyncActionSignerResponse = {
    verifyRequestID: 0,
    expireAt: "",
};
exports.MsgSubmitSyncActionSignerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.verifyRequestID !== 0) {
            writer.uint32(8).uint64(message.verifyRequestID);
        }
        if (message.expireAt !== "") {
            writer.uint32(18).string(message.expireAt);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSubmitSyncActionSignerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.verifyRequestID = longToNumber(reader.uint64());
                    break;
                case 2:
                    message.expireAt = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSubmitSyncActionSignerResponse);
        if (object.verifyRequestID !== undefined &&
            object.verifyRequestID !== null) {
            message.verifyRequestID = Number(object.verifyRequestID);
        }
        else {
            message.verifyRequestID = 0;
        }
        if (object.expireAt !== undefined && object.expireAt !== null) {
            message.expireAt = String(object.expireAt);
        }
        else {
            message.expireAt = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.verifyRequestID !== undefined &&
            (obj.verifyRequestID = message.verifyRequestID);
        message.expireAt !== undefined && (obj.expireAt = message.expireAt);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgSubmitSyncActionSignerResponse);
        if (object.verifyRequestID !== undefined &&
            object.verifyRequestID !== null) {
            message.verifyRequestID = object.verifyRequestID;
        }
        else {
            message.verifyRequestID = 0;
        }
        if (object.expireAt !== undefined && object.expireAt !== null) {
            message.expireAt = object.expireAt;
        }
        else {
            message.expireAt = "";
        }
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
    }
    CreateMintRequest(request) {
        const data = exports.MsgCreateMintRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "CreateMintRequest", data);
        return promise.then((data) => exports.MsgCreateMintRequestResponse.decode(new minimal_1.Reader(data)));
    }
    SubmitMintResponse(request) {
        const data = exports.MsgSubmitMintResponse.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "SubmitMintResponse", data);
        return promise.then((data) => exports.MsgSubmitMintResponseResponse.decode(new minimal_1.Reader(data)));
    }
    CreateActionRequest(request) {
        const data = exports.MsgCreateActionRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "CreateActionRequest", data);
        return promise.then((data) => exports.MsgCreateActionRequestResponse.decode(new minimal_1.Reader(data)));
    }
    SubmitActionResponse(request) {
        const data = exports.MsgSubmitActionResponse.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "SubmitActionResponse", data);
        return promise.then((data) => exports.MsgSubmitActionResponseResponse.decode(new minimal_1.Reader(data)));
    }
    CreateVerifyCollectionOwnerRequest(request) {
        const data = exports.MsgCreateVerifyCollectionOwnerRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "CreateVerifyCollectionOwnerRequest", data);
        return promise.then((data) => exports.MsgCreateVerifyCollectionOwnerRequestResponse.decode(new minimal_1.Reader(data)));
    }
    SubmitVerifyCollectionOwner(request) {
        const data = exports.MsgSubmitVerifyCollectionOwner.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "SubmitVerifyCollectionOwner", data);
        return promise.then((data) => exports.MsgSubmitVerifyCollectionOwnerResponse.decode(new minimal_1.Reader(data)));
    }
    SetMinimumConfirmation(request) {
        const data = exports.MsgSetMinimumConfirmation.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "SetMinimumConfirmation", data);
        return promise.then((data) => exports.MsgSetMinimumConfirmationResponse.decode(new minimal_1.Reader(data)));
    }
    CreateActionSigner(request) {
        const data = exports.MsgCreateActionSigner.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "CreateActionSigner", data);
        return promise.then((data) => exports.MsgCreateActionSignerResponse.decode(new minimal_1.Reader(data)));
    }
    UpdateActionSigner(request) {
        const data = exports.MsgUpdateActionSigner.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "UpdateActionSigner", data);
        return promise.then((data) => exports.MsgUpdateActionSignerResponse.decode(new minimal_1.Reader(data)));
    }
    DeleteActionSigner(request) {
        const data = exports.MsgDeleteActionSigner.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "DeleteActionSigner", data);
        return promise.then((data) => exports.MsgDeleteActionSignerResponse.decode(new minimal_1.Reader(data)));
    }
    CreateActionSignerConfig(request) {
        const data = exports.MsgCreateActionSignerConfig.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "CreateActionSignerConfig", data);
        return promise.then((data) => exports.MsgCreateActionSignerConfigResponse.decode(new minimal_1.Reader(data)));
    }
    UpdateActionSignerConfig(request) {
        const data = exports.MsgUpdateActionSignerConfig.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "UpdateActionSignerConfig", data);
        return promise.then((data) => exports.MsgUpdateActionSignerConfigResponse.decode(new minimal_1.Reader(data)));
    }
    DeleteActionSignerConfig(request) {
        const data = exports.MsgDeleteActionSignerConfig.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "DeleteActionSignerConfig", data);
        return promise.then((data) => exports.MsgDeleteActionSignerConfigResponse.decode(new minimal_1.Reader(data)));
    }
    CreateSyncActionSigner(request) {
        const data = exports.MsgCreateSyncActionSigner.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "CreateSyncActionSigner", data);
        return promise.then((data) => exports.MsgCreateSyncActionSignerResponse.decode(new minimal_1.Reader(data)));
    }
    SubmitSyncActionSigner(request) {
        const data = exports.MsgSubmitSyncActionSigner.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Msg", "SubmitSyncActionSigner", data);
        return promise.then((data) => exports.MsgSubmitSyncActionSignerResponse.decode(new minimal_1.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
//# sourceMappingURL=tx.js.map